module.exports = __webpack_public_path__ + "img/sushi-1024.151f6aab.jpg";